module.exports = __webpack_public_path__ + "img/30ne.3e375407.svg";